import { useState, useEffect } from 'react';
import { AlertTriangle, Phone, MapPin, X } from 'lucide-react';
import './EmergencySOS.css';

export default function EmergencySOS() {
  const [isOpen, setIsOpen] = useState(false);
  const [location, setLocation] = useState(null);
  const [what3words, setWhat3words] = useState('');

  useEffect(() => {
    if (isOpen && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude.toFixed(6);
          const lon = position.coords.longitude.toFixed(6);
          setLocation({ lat, lon });
          
          // What3words würde hier API-Call brauchen (kostenpflichtig)
          // Für MVP: Placeholder
          setWhat3words('///example.words.here');
        },
        (error) => {
          console.error('GPS Error:', error);
          setLocation({ lat: 'N/A', lon: 'N/A' });
        }
      );
    }
  }, [isOpen]);

  if (!isOpen) {
    return (
      <button 
        className="sos-trigger-btn" 
        onClick={() => setIsOpen(true)}
        title="Notfall SOS"
      >
        <AlertTriangle size={24} />
        SOS
      </button>
    );
  }

  return (
    <div className="sos-overlay">
      <div className="sos-container">
        <button className="sos-close" onClick={() => setIsOpen(false)}>
          <X size={32} />
        </button>

        <div className="sos-header">
          <AlertTriangle size={64} />
          <h1>NOTFALL</h1>
        </div>

        <div className="sos-emergency-numbers">
          <a href="tel:112" className="sos-number sos-112">
            <Phone size={40} />
            <div>
              <div className="number">112</div>
              <div className="label">Notruf EU</div>
            </div>
          </a>
          <a href="tel:999" className="sos-number sos-999">
            <Phone size={40} />
            <div>
              <div className="number">999</div>
              <div className="label">Emergency UK</div>
            </div>
          </a>
        </div>

        <div className="sos-location">
          <h3><MapPin size={20} /> Dein Standort:</h3>
          {location ? (
            <>
              <div className="location-coords">
                <strong>GPS:</strong> {location.lat}, {location.lon}
              </div>
              <div className="location-link">
                <a 
                  href={`https://www.google.com/maps?q=${location.lat},${location.lon}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  📍 In Google Maps öffnen
                </a>
              </div>
            </>
          ) : (
            <p>GPS wird ermittelt...</p>
          )}
        </div>

        <div className="sos-info">
          <h3>Wichtige Infos für Rettung:</h3>
          <ul>
            <li>🏥 Nächstes Krankenhaus: <strong>Siehe Karte oben</strong></li>
            <li>🚁 Helikopter-Landung: Offenes Gelände suchen</li>
            <li>📱 Akku sparen: Nach Anruf in Flugmodus</li>
            <li>👥 Sichtbar bleiben: Helle Kleidung, winken</li>
          </ul>
          <a href="/first-aid" className="first-aid-link" target="_blank">
            🏥 Erste-Hilfe Guide öffnen
          </a>
        </div>

        <div className="sos-mountain-rescue">
          <h3>🏔️ Mountain Rescue (Schottland):</h3>
          <p><a href="tel:999">999</a> und nach "Mountain Rescue" fragen</p>
          <p className="sos-note">Kostenlos, auch ohne Netz SMS an 999 möglich</p>
        </div>
      </div>
    </div>
  );
}
